import { useCallback } from 'react';
import { useOverwolfStore } from './use-overwolf-store';

// -----------------------------------------------------------------------------
// Returns a copy-to-clipboard function. Inside the Overwolf client the web
// clipboard API is unreliable, so it asks the shell to copy through the native
// client (overwolf.utils.placeOnClipboard via odk-ts) over the store bridge; on
// the web (no shell bridge) it uses navigator.clipboard.
const useCopyToClipboard = (): ((text: string) => Promise<void>) => {
  const { isAvailable, placeOnClipboard } = useOverwolfStore();

  return useCallback(
    async (text: string): Promise<void> => {
      if (isAvailable) {
        placeOnClipboard(text);
        return;
      }

      await navigator.clipboard.writeText(text);
    },
    [isAvailable, placeOnClipboard],
  );
};

export default useCopyToClipboard;
